import React, { useEffect } from "react";
import { CheckCircle, Home, Shield, Activity } from "react-feather";

const CTASection = () => {

    return (
        <section className="py-5 bg-light">
            <div className="container">

                <div className="row align-items-center justify-content-between">

                    {/* Left Content */}
                    <div
                        className="col-lg-7 mb-4 mb-lg-0"
                        data-aos="fade-right"
                    >
                        <h2 className="fw-bold mb-3 text-dark">
                            Transform Your Hospital with Smart <span className="lanp-secondary-text">Digital Technology</span>
                        </h2>

                        <p className="text-dark mb-4">
                            Upgrade hospital operations with a powerful and scalable Hospital Management Software (HMS).
                            Digitize patient records, automate appointment scheduling, streamline billing processes,
                            and enhance healthcare efficiency with an all-in-one smart digital solution.
                        </p>

                        <div className="d-flex flex-wrap gap-3 mb-4 text-dark">

                            <div className="d-flex align-items-center">
                                <CheckCircle className="lanp-secondary-text me-2" size={18} />
                                <span>Secure Digital Patient Records</span>
                            </div>

                            <div className="d-flex align-items-center">
                                <CheckCircle className="lanp-secondary-text me-2" size={18} />
                                <span>Automated Scheduling System</span>
                            </div>

                            <div className="d-flex align-items-center">
                                <CheckCircle className="lanp-secondary-text me-2" size={18} />
                                <span>Accurate Billing & Reports</span>
                            </div>

                            <div className="d-flex align-items-center">
                                <CheckCircle className="lanp-secondary-text me-2" size={18} />
                                <span>Real-Time Data & Analytics</span>
                            </div>

                        </div>

                        <div className="d-flex gap-3 flex-wrap">
                            <a href="/book-demo" className="btn lanp-btn-primary px-4 py-2 fw-semibold rounded-pill">
                                Book Free Demo
                            </a>

                            <a href="#enquirynow" className="btn lanp-btn-primary px-4 py-2 fw-semibold rounded-pill">
                                Learn More
                            </a>
                        </div>
                    </div>

                    {/* Right Card */}
                    <div
                        className="col-lg-5"
                        data-aos="zoom-in"
                    >
                        <div className="card shadow-lg border-0">
                            <div className="card-body p-4">

                                <h5 className="fw-bold mb-3">
                                    Why Choose Smart HMS?
                                </h5>

                                <div className="d-flex mb-3">
                                    <Home className="text-danger me-3" size={24} />
                                    <div>
                                        <strong>All-in-One Platform</strong>
                                        <p className="text-muted mb-0 small">
                                            Manage patients, staff, billing, and reports from one dashboard.
                                        </p>
                                    </div>
                                </div>

                                <div className="d-flex mb-3">
                                    <Shield className="lanp-secondary-text me-3" size={24} />
                                    <div>
                                        <strong>Data Security</strong>
                                        <p className="text-muted mb-0 small">
                                            Advanced encryption keeps patient data safe and compliant.
                                        </p>
                                    </div>
                                </div>

                                <div className="d-flex mb-3">
                                    <Activity className="lanp-secondary-text me-3" size={24} />
                                    <div>
                                        <strong>Faster Operations</strong>
                                        <p className="text-muted mb-0 small">
                                            Improve workflow efficiency and reduce patient wait time.
                                        </p>
                                    </div>
                                </div>

                                <a href="#enquirynow" className="btn lanp-btn-primary w-100 mt-3 fw-semibold rounded-pill">
                                    Get Started Today
                                </a>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default CTASection;